<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Crear producto</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submitProduct">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">SKU (Código único)</label>
                                    <argon-input v-model="product.sku" type="text" placeholder="Ej: LAP001" />
                                    <small v-if="submitted && v$.product.sku.$error" class="text-danger">SKU requerido y único</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Nombre</label>
                                    <argon-input v-model="product.name" type="text" placeholder="Ej: Laptop Dell" />
                                    <small v-if="submitted && v$.product.name.$error" class="text-danger">Nombre requerido</small>
                                </div>

                                <div class="col-md-12">
                                    <label class="form-control-label">Descripción</label>
                                    <argon-input v-model="product.description" type="textarea" rows="3" placeholder="Descripción detallada del producto" />
                                    <small v-if="submitted && v$.product.description.$error" class="text-danger">Descripción requerida</small>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-label mb-1">Unidad de Medida</label>
                                    <ArgonLookup
                                        :options="units"
                                        v-model="unitSelected"
                                        track-by="id"
                                        display-key="name"
                                        placeholder="Seleccione la unidad..."
                                    >
                                        <template #option="{ option }">
                                            <span>
                                                <span class="font-weight-bold">{{ option.code }}</span>
                                                ({{ option.name }})
                                            </span>
                                        </template>
                                    </ArgonLookup>
                                    <small v-if="loadingUnits" class="text-muted">Cargando unidades...</small>
                                    <small v-if="submitted && v$.product.unit_id.$error" class="text-danger">Unidad requerida.</small>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-label mb-1">Categoría</label>
                                    <ArgonLookup
                                        :options="categories"
                                        v-model="categorySelected"
                                        display-key="name"
                                        track-by="id"
                                        placeholder="Seleccione la categoría..."
                                    >
                                        <template #option="{ option }">
                                            <span>
                                                {{ option.name }}
                                            </span>
                                        </template>
                                    </ArgonLookup>
                                    <small v-if="loadingCategories" class="text-muted">Cargando categorías...</small>
                                    <small v-if="submitted && v$.product.category.$error" class="text-danger">Categoría requerida.</small>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-control-label">Precio de Costo</label>
                                    <argon-input v-model="product.price" type="number" step="0.01" placeholder="0.00" />
                                    <small v-if="submitted && v$.product.price.$error" class="text-danger">Precio de costo requerido y mayor a 0</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Precio de Venta</label>
                                    <argon-input v-model="product.sale_price" type="number" step="0.01" placeholder="0.00" />
                                    <small v-if="submitted && v$.product.sale_price.$error" class="text-danger">Precio de venta requerido y mayor a 0</small>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-control-label">Gravable (Impuesto)</label>
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            v-model="product.taxable"
                                            id="taxable"
                                        />
                                        <label class="form-check-label" for="taxable">Sí, aplica impuestos</label>
                                    </div>
                                    <small v-if="submitted && v$.product.taxable.$error" class="text-danger">Campo requerido</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Estado</label>
                                    <select class="form-control" v-model="product.state">
                                        <option value="">Seleccione un estado</option>
                                        <option :value="1">Activo</option>
                                        <option :value="2">Inactivo</option>
                                    </select>
                                    <small v-if="submitted && v$.product.state.$error" class="text-danger">Estado requerido</small>
                                </div>

                                <div class="col-md-12 mt-3 text-center">
                                    <div>
                                        <label class="form-control-label">Foto del producto</label>
                                    </div>
                                    <div class="image-upload-area mx-auto" @click="uploadPhoto()">
                                        <img :src="product.photo_url || fileUpload" alt="Foto producto" class="img-thumbnail" style="max-width:200px; height: auto; display: block;" @error="handleImageError" />
                                        <input type="file" style="display: none !important;" ref="productPhotoFile" accept="image/jpeg, image/png" @change="onFileChange($event)">
                                    </div>
                                    <small class="text-muted d-block mt-1">Haz clic en la imagen para subir una foto.</small>
                                    <small v-if="submitted && v$.product.photo_url.$error" class="text-danger d-block">La foto del producto es requerida.</small>
                                </div>
                                </div>

                            <argon-button
                                type="submit"
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                            >
                                Guardar Producto
                            </argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonLookup from "@/components/ArgonLookup.vue";
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';
// 🛑 Importar el placeholder de la imagen 🛑
import fileUpload from '@/assets/img/uploadfile.jpg';

const companyId = localStorage.getItem('companyId');

export default {
    name: "CreateProduct", // Cambiado de ProductForm a CreateProduct
    components: { ArgonInput, ArgonButton, ArgonLookup },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            fileUpload, // Disponible en la plantilla
            submitted: false,
            loadingCategories: false,
            loadingUnits: false,
            // 🛑 Valores iniciales para lookups adaptados a la lógica de creación
            categorySelected: null,
            unitSelected: null,
            categories: [],
            units: [],
            product: {
                sku: '',
                name: '',
                description: '',
                unit_id: null, // Debe ser null para Lookups
                price: 0.00,
                sale_price: 0.00,
                taxable: false,
                category: null, // Debe ser null para Lookups (ID de categoría)
                state: 1, // '1' por defecto (Activo)
                photo_url: null, // Inicializado como null
                company: parseInt(companyId) // Aseguramos que sea número
            }
        };
    },
    validations() {
        return {
            product: {
                sku: { required: helpers.withMessage('SKU requerido', required) },
                name: { required: helpers.withMessage('Nombre requerido', required) },
                description: { required: helpers.withMessage('Descripción requerida', required) },
                unit_id: { required: helpers.withMessage('Unidad requerida', required) },
                price: { required, minValue: helpers.withMessage('Debe ser mayor a 0', (value) => value > 0) },
                sale_price: { required, minValue: helpers.withMessage('Debe ser mayor a 0', (value) => value > 0) },
                category: { required: helpers.withMessage('Categoría requerida', required) },
                state: { required: helpers.withMessage('Estado requerido', required) },
                // 🛑 photo_url debe ser requerido si la foto es obligatoria al crear 🛑
                photo_url: {
                    required: helpers.withMessage('La foto es requerida.', required),
                    url: helpers.withMessage('Debe ser una URL válida', (value) => !value || /^https?:\/\/.+/.test(value))
                },
                taxable: { required }
            }
        };
    },
    watch:{
        categorySelected(newVal){
            this.product.category = newVal ? newVal.id : null;
        },
        unitSelected(newVal){
            this.product.unit_id = newVal ? newVal.id : null;
        }
    },
    methods: {
        // 🛑 Lógica para disparar el selector de archivos 🛑
        uploadPhoto() {
            this.$refs.productPhotoFile.click();
        },

        // 🛑 Lógica para subir el archivo 🛑
        onFileChange(event) {
            const file = event.target.files[0];
            if (!file) return;

            const self = this;
            let formData = new FormData();
            formData.append('file', file);
            formData.append('fileName', file.name);
            //const token = localStorage.getItem("accessToken");

            // 🛑 CRÍTICO: Llamada Axios a tu servicio de archivos 🛑
            axios.post(this.$store.state.fileURL, formData,
                {
                headers: {
                    "Authorization": "Basic cHJpdmF0ZV9XVXVROG1DQncxV210WHc1empIa3NGQkNZQ1E9Og==",
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function(result){
                self.product.photo_url = result.data.url;
                Swal.fire('Subida exitosa', 'La imagen fue cargada al servidor.', 'success');
            }).catch(err => {
                console.error("Error al subir archivo:", err.response || err);
                Swal.fire('Error', 'Fallo al subir el archivo.', 'error');
                self.product.photo_url = null; // Limpiar URL si falla
            });
        },

        handleImageError(event) {
            event.target.src = this.fileUpload;
        },

        async fetchUnits(config){
            this.loadingUnits = true;
            try {
                const result = await axios.get(this.$store.state.apiURL+'units?company='+companyId, config);
                this.units = result.data.map(item => ({ id: item.id, code:item.code, name:item.name }));
            } catch (error) {
                this.handleSessionError(error);
            } finally {
                this.loadingUnits = false;
            }
        },
        async fetchCategories(config){
            this.loadingCategories = true;
            try {
                const result = await axios.get(this.$store.state.apiURL+'products_category?company='+companyId, config);
                this.categories = result.data.map(item => ({ id: item.id, name: item.name, code: item.code }));
            } catch (error) {
                this.handleSessionError(error);
            } finally {
                this.loadingCategories = false;
            }
        },

        // 🛑 Adaptado para POST (Creación) 🛑
        async submitProduct() {
            this.submitted = true;
            this.v$.$touch();

            if (this.v$.$invalid) {
                Swal.fire({ title: 'Datos inválidos', text: 'Por favor, revisa los campos requeridos.', icon: 'warning', confirmButtonColor: '#0b9257' });
                return;
            }

            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            const config = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` } };

            try {
                // 🛑 POST para la creación de un nuevo producto 🛑
                await axios.post(`${apiURL}products`, this.product, config);

                Swal.fire({
                    title: 'Producto creado',
                    text: 'El producto fue registrado correctamente.',
                    icon: 'success',
                    confirmButtonColor: '#0b9257'
                }).then(() => {
                    this.$router.push('/products');
                });

            } catch (err) {
                console.error('Error al guardar producto:', err.response || err);
                const errorText = (err.response && err.response.data && err.response.data.error)
                                 ? err.response.data.error : 'No se pudo guardar el producto. Verifique el SKU.';
                Swal.fire({ title: 'Error', text: errorText, icon: 'error', confirmButtonColor: '#0b9257' });
            }
        },

        // Manejo de error de sesión (mantenido)
        handleSessionError(error) {
            const self = this;
            if (error.response && error.response.status === 401) {
                Swal.fire({
                    title: 'Sesión',
                    text: 'El tiempo de sesión ha vencido, ingresa nuevamente.',
                    icon:'warning',
                    confirmButtonColor:'#bf4f51',
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });
            }
        }
    },
    async mounted(){
        const token = localStorage.getItem("accessToken");
        const config = { headers: { 'Authorization': `Bearer ${token}` } };

        // Carga de lookups al montar
        await Promise.all([
            this.fetchUnits(config),
            this.fetchCategories(config)
        ]);
    }
};
</script>

<style scoped>
.image-upload-area {
    cursor: pointer;
    border: 2px dashed #ccc;
    padding: 10px;
    margin-top: 10px;
    border-radius: 8px;
    display: inline-block;
}
.image-upload-area:hover {
    border-color: #5e72e4;
}
</style>